// extracted by mini-css-extract-plugin
export var closeButton = "_fv-2";
export var closeButtonIcon = "_fv-3";
export var lightboxContent = "_fv-1";
export var lightboxOverlay = "_fv-0";